const business = () => import('./business');
const sayer = () => import('./sayer2022');
const channel = () => import('./channel2022');
const adminChannel = () => import('./adminChannel');
const markCenterChannel = () => import('./markCenterChannel');
const writer = () => import('./writer2020');
const userPortrait = () => import('./userPortrait');
const departmentMoney = () => import('./departmentMoney');
const departmentMoneyEdit = () => import('./departmentMoneyEdit');
const departmentMoneyNew = () => import('./departmentMoneyNew');
const bossview = () => import('./bossview');
const yearReport = () => import('./year_report');
const formView = () => import('./interview/formview');
const channelResource = () => import('./channelResource');
const interviewStatus = () => import('./interview/interviewStatus');
const interviewResult = () => import('./interview/interviewResult');
const fibSync = () => import('./fibSync');
const jpWriter = () => import('./jpWriter');
const jpWriterStatus = () => import('./jpWriterStatus');
const reuseList = () => import('./reuseList');
const viewTraining = () => import('@/training/pages/resource/resourceEdit');
const viewFib = () => import('@/pages/student/editStudent');

const biRouter = [
  {
    path: '/bi/business', name: 'biBusiness', component: business, meta: { c: 'bi', a: 'business' }
  },
  {
    path: '/bi/sayer', name: 'biSayer', component: sayer, meta: { c: 'bi', a: 'sayer' }
  },
  {
    path: '/bi/channel', name: 'biChannel', component: channel, meta: { c: 'bi', a: 'channel' }
  },
  {
    path: '/bi/adminChannel', name: 'biAdminChannel', component: adminChannel, meta: { c: 'bi', a: 'adminChannel' }
  },
  {
    path: '/bi/markCenterChannel', name: 'biMarkCenterChannel', component: markCenterChannel, meta: { c: 'bi', a: 'markCenterChannel' }
  },
  {
    path: '/bi/writer', name: 'biWriter', component: writer, meta: { c: 'bi', a: 'writer' }
  },
  {
    path: '/bi/userPortrait', name: 'biUserPortrait', component: userPortrait, meta: { c: 'bi', a: 'userPortrait' }
  },
  {
    path: '/bi/departmentMoney', name: 'departmentMoney', component: departmentMoney, meta: { c: 'bi', a: 'departmentMoney' }
  },
  {
    path: '/bi/departmentMoneyEdit', name: 'departmentMoneyEdit', component: departmentMoneyEdit, meta: { c: 'bi', a: 'departmentMoneyEdit' }
  },
  {
    path: '/bi/bossview', name: 'biBossview', component: bossview, meta: { c: 'bi', a: 'bossview' }
  },
  {
    path: '/bi/departmentMoneyNew', name: 'departmentMoneyNew', component: departmentMoneyNew, meta: { c: 'bi', a: 'departmentMoneyNew' }
  },
  {
    path: '/bi/year_report', name: 'year_report', component: yearReport, meta: { c: 'bi', a: 'year_report' }
  },
  {
    path: '/bi/interview/formview', name: 'formview', component: formView, meta: { c: 'interview', a: 'formview' }
  },
  {
    path: '/bi/resource', name: 'resource', component: channelResource, meta: { c: 'bi', a: 'resource' }
  },
  {
    path: '/bi/interview/interviewStatus', name: 'interviewStatus', component: interviewStatus, meta: { c: 'interview', a: 'interviewStatus' }
  },
  {
    path: '/bi/interview/interviewResult', name: 'interviewResult', component: interviewResult, meta: { c: 'interview', a: 'interviewResult' }
  },
  {
    path: '/bi/fibSync', name: 'fibSync', component: fibSync, meta: { c: 'bi', a: 'fibSync' }
  },
  {
    path: '/bi/jpWriter', name: 'jpWriter', component: jpWriter, meta: { c: 'bi', a: 'jpWriter' }
  },
  {
    path: '/bi/jpWriterStatus', name: 'jpWriterStatus', component: jpWriterStatus, meta: { c: 'bi', a: 'jpWriterStatus' }
  },
  {
    path: '/bi/reuseList', name: 'reuseList', component: reuseList, meta: { c: 'bi', a: 'reuseList' }
  },
  {
    path: '/trainingreuse/view/:id', name: 'trainingReuseDetail', component: viewTraining, meta: { c: 'trainingreuse', a: 'view', readOnly: true }
  },
  {
    path: '/fibreuse/view/:id', name: 'fibReuseDetail', component: viewFib, meta: { c: 'fibreuse', a: 'view', readOnly: true },
  },
];

export default biRouter;
